import { Flex, HStack, Text } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { ExportButton } from './ExportButton';
import { UpdateListButton } from './UpdateListButton';
import { ExportType } from '@/model';

interface TableListSimpleControlsProps {
  extraRightOptions?: ReactNode;
  onUpdateList?: () => void;
  onExport?: (exportType: ExportType) => void;
}

export const TableListSimpleControls = ({ extraRightOptions, onUpdateList, onExport }: TableListSimpleControlsProps) => {
  return (
    <Flex gap='micro' justify='space-between'>
      <ExportButton onExport={onExport} />

      <HStack divider={<Text color='brand.500'> | </Text>} gap='micro'>
        <UpdateListButton onClick={onUpdateList} />
        {!!extraRightOptions && extraRightOptions}
      </HStack>
    </Flex>
  );
};
